import Http from '@/services/http';
import { Lookup } from 'sigma-mappings';

const urls = {
  getCompanies: '/empresa',
};

export default {
  /**
   * Lista as empresas (perfilEmpresaId, nome) que o usuário possui acesso
   */
  getCompanies() {
    const http = new Http();
    return http.post(urls.getCompanies)
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
};
